import React from 'react'
  import Layout from '../../component/layout/layout'
import Section1 from '../../component/form2/form'
export default () => {
    return (
        <Layout>
        <Section1/>
         </Layout>
    );
}